import React, { useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  index: number;
  isInView: boolean;
}
function FAQItem({
  question,
  answer,
  index,
  isInView
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {
    opacity: 0,
    y: 20
  }} transition={{
    delay: index * 0.1,
    duration: 0.6
  }} className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-13">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-6 text-left hover:bg-gray-50 transition-colors" data-id="element-14">
        <h3 className="text-lg md:text-xl font-semibold text-[#0f172a] pr-4" data-id="element-15">
          {question}
        </h3>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} data-id="element-16">
          <ChevronDownIcon className="w-6 h-6 text-[#d4a853] flex-shrink-0" data-id="element-17" />
        </motion.div>
      </button>

      <AnimatePresence data-id="element-18">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-19">
            <div className="px-6 pb-6 text-gray-700 leading-relaxed" data-id="element-20">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}
export function FAQ() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const faqs = [{
    question: '¿Tengo que comprar equipos caros?',
    answer: 'No, el protocolo usa elementos que ya tienes en casa.'
  }, {
    question: '¿Funciona si estoy en la menopausia?',
    answer: 'Sí, está diseñado específicamente para los cambios hormonales de esta etapa.'
  }, {
    question: '¿Es un libro largo?',
    answer: 'No, es una guía práctica diseñada para leerse en 15 minutos y aplicarse hoy mismo.'
  }, {
    question: '¿Recibiré algo por correo?',
    answer: 'Es un producto 100% digital con acceso inmediato tras la compra.'
  }];
  return <section ref={ref} className="w-full bg-[#faf5eb] py-20 md:py-32" data-id="element-21">
      <div className="max-w-4xl mx-auto px-6" data-id="element-22">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 40
      }} transition={{
        duration: 0.8
      }} className="space-y-12" data-id="element-23">
          <h2 className="text-3xl md:text-4xl lg:text-5xl text-[#0f172a] text-center" data-id="element-24">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-25">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} index={index} isInView={isInView} data-id="element-26" />)}
          </div>
        </motion.div>
      </div>
    </section>;
}